export const mock = [
  {
    value: 'storeId',
    label: 'chi nhánh'
  },
  {
    value: 'yeucautao',
    label: 'Yêu cầu tạo khách ở ECC'
  },
  {
    value: 'customerAccountGroupCode',
    label: 'Phân nhóm khách hàng'
  },
  {
    value: 'ngaytao',
    label: 'Ngày tạo'
  },
  {
    value: 'actived',
    label: 'Trạng thái'
  },
  {
    value: 'email',
    label: 'Email'
  },
  {
    value: 'phanHang',
    label: 'Phân hạng KH'
  },
  {
    value: 'adminEmployee',
    label: 'NV Admin'
  },
  {
    value: 'createByCode',
    label: 'Người tạo'
  },
  {
    value: 'saleOfficeCode',
    label: 'Khu vực'
  },
  {
    value: 'customerTypeCode',
    label: 'Phân loại KH'
  },
  {
    value: 'companyId',
    label: 'Công ty'
  },
  {
    value: 'provinceId',
    label: 'Tỉnh/Thành phố'
  },
  {
    value: 'districtId',
    label: 'Quận/Huyện'
  },
  {
    value: 'wardId',
    label: 'Phường/xã'
  },
  {
    value: 'addressTypeCode',
    label: 'Loại địa chỉ'
  },
  {
    value: 'address',
    label: 'Địa chỉ'
  },
  {
    value: 'customerGroupCode',
    label: 'Nhóm khách hàng'
  },
  {
    value: 'customerCareerCode',
    label: 'Ngành nghề'
  },
  {
    value: 'rolesCode',
    label: 'Phòng ban'
  },
  {
    value: 'salesEmployeeCode',
    label: 'NV kinh doanh'
  },
  {
    value: 'personInCharge6Code',
    label: 'Nhân viên TVVL'
  },
  {
    value: 'customerSourceCode',
    label: 'Nguồn khách hàng'
  },
]
